function Header() {
  return (
    <header>
      <h1>Pokedex</h1>
    </header>
  );
}

export default Header;
